import { Resource } from '@redge-media/fo-js-sdk';
import Banner from './banner';

const Banners = Resource.extend({
  endpoint: '/products/banners',

  constructor: function Banners(opts = {}) {
    Resource.call(this);

    this.label = opts.label || 'main';
    this.recordClass = Banner;
  },

  getPath(method, props = {}) {
    let path = Resource.prototype.getPath.call(this, method, props);
    if (method === 'fetchAll') {
      path += `/${this.label}`;
    }

    return path;
  },
});

export default Banners;
